import { PortfolioPage, PortfolioPageProps } from "./ui/starfall-portfolio-landing";
import foraLogo from "../resources/projects/fora-logo.png";
import foraPreview from "../resources/projects/fora-preview.png";
import sortableLogo from "../resources/projects/sortable-logo.png";
import sortablePreview from "../resources/projects/sortable-preview.png";
import aurasphereLogo from "../resources/projects/aurasphere-logo.png";
import auraspherePreview from "../resources/projects/aurasphere-preview.png";
import heirloomLogo from "../resources/projects/heirloom-logo.png";
import heirloomPreview from "../resources/projects/heirloom-preview.png";
import drbnLogo from "../resources/projects/drbn-logo.png";
import drbnPreview from "../resources/projects/drbn-preview.png";

const customPortfolioData: PortfolioPageProps = {
  logo: {
    initials: 'WN',
    name: 'William Wilder Nash',
  },
  navLinks: [],
  hero: {
    titleLine1: 'Software Engineer &',
    titleLine2Gradient: 'Technology Consultant',
    subtitle: 'I build scalable web applications with a focus on user experience and performance.',
  },
  ctaButtons: {
    primary: {
      label: 'Explore My Work',
      onClick: () => { document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' }); },
    },
  },
  projects: [
    {
      id: 'fora',
      title: 'Fora',
      description: 'A productivity platform with operational systems needed to support growth.',
      tags: ['Full Stack', 'Stripe', 'Analytics', 'Project Management'],
      logoSrc: foraLogo,
      logoAlt: 'Fora logo',
      modalImageSrc: foraPreview,
      modalImageAlt: 'Fora product preview',
      modalImageFit: 'contain',
      siteHref: 'https://usefora.com',
      features: [
        {
          id: 'fora-full-stack',
          title: 'Full Stack',
          description: 'Used Google\'s SQL database, Express.js and React.',
        },
        {
          id: 'fora-stripe',
          title: 'Stripe',
          description: 'Monthly subscriptions powered by Stripe.',
        },
        {
          id: 'fora-analytics',
          title: 'Analytics',
          description: 'Created standalone dashboard to power business decisions.',
        },
        {
          id: 'fora-project-management',
          title: 'Project Management',
          description: 'Productivity platform for event planners',
        },
      ],
    },
    {
      id: 'sortable',
      title: 'Sortable',
      description: 'A pairwise ranking app where users build personal and aggregate list rankings.',
      tags: ['Full Stack', 'Ranking', 'iOS', 'Cloud Run'],
      logoSrc: sortableLogo,
      logoAlt: 'Sortable logo',
      logoContainerClassName: 'h-20 w-20 sm:h-24 sm:w-24',
      logoClassName: 'rounded-2xl object-cover',
      modalImageSrc: sortablePreview,
      modalImageAlt: 'Sortable product preview',
      modalImageFit: 'contain',
      siteHref: 'https://sortable.net',
      features: [
        {
          id: 'sortable-ranking',
          title: 'Pairwise Ranking',
          description: 'Elo-style aggregate scores from head-to-head choices.',
        },
        {
          id: 'sortable-full-stack',
          title: 'Full Stack',
          description: 'Front end and backend deployed with GCS',
        },
        {
          id: 'sortable-ios',
          title: 'Native iOS',
          description: 'sortable.net is live on the App Store.',
        },
        {
          id: 'sortable-moderation',
          title: '3rd Parties',
          description: 'Create lists with IMDB, Spotify and more',
        },
      ],
    },
    {
      id: 'aurasphere',
      title: 'AuraSphere',
      description: 'A social platform for sharing posts, giving aura points, and connecting through clubs and events.',
      tags: ['Full Stack', 'Social', 'Real-time', 'Mobile'],
      logoSrc: aurasphereLogo,
      logoAlt: 'AuraSphere logo',
      logoContainerClassName: 'h-20 w-20 rounded-2xl bg-white p-3 sm:h-24 sm:w-24 sm:p-4',
      modalImageSrc: auraspherePreview,
      modalImageAlt: 'AuraSphere product preview',
      modalImageFit: 'contain',
      siteHref: 'https://aurasphere.io',
      features: [
        {
          id: 'aurasphere-social',
          title: 'Social Feed',
          description: 'Posts, comments, mentions, "re-spheres".',
        },
        {
          id: 'aurasphere-aura',
          title: 'Aura System',
          description: 'Category-based point giving.',
        },
        {
          id: 'aurasphere-realtime',
          title: 'Real-time',
          description: 'Socket.io messaging, live notifications, and mobile push delivery.',
        },
        {
          id: 'aurasphere-mobile',
          title: 'eCommerce',
          description: 'Stripe enabled for in-app purchases',
        },
      ],
    },
    {
      id: 'heirloom',
      title: 'Heirloom',
      description: 'A memory-preservation product designed for a mobile-first launch.',
      tags: ['MVP', 'Social', 'Branded', 'Mobile'],
      logoSrc: heirloomLogo,
      logoAlt: 'Heirloom logo',
      modalImageSrc: heirloomPreview,
      modalImageAlt: 'Heirloom product preview',
      modalImageFit: 'contain',
      siteHref: 'https://expensive-guide.surge.sh/',
      features: [
        {
          id: 'heirloom-mvp',
          title: 'MVP',
          description: 'Completely frontend with mock backend data.',
        },
        {
          id: 'heirloom-social',
          title: 'Social',
          description: 'Supports shared storytelling and group dynamics',
        },
        {
          id: 'heirloom-branded',
          title: 'Branded',
          description: 'Crafted a distinct visual identity and cohesive style guide',
        },
        {
          id: 'heirloom-mobile',
          title: 'Mobile',
          description: 'Responsive layouts for a mobile first experience',
        },
      ],
    },
    {
      id: 'dr-bridget-nash',
      title: 'Dr. Bridget Nash',
      description: 'A content-led therapy site built to improve discovery, trust, and conversion.',
      tags: ['Blog', 'Calendar', 'Podcast', 'SEO'],
      logoSrc: drbnLogo,
      logoAlt: 'Dr. Bridget Nash logo',
      modalImageSrc: drbnPreview,
      modalImageAlt: 'Dr. Bridget Nash site preview',
      modalImageFit: 'contain',
      siteHref: 'https://drbridgetnash-web-724764677828.us-central1.run.app/',
      features: [
        {
          id: 'drbn-blog',
          title: 'Blog',
          description: 'Connected to Blogger to create on site content',
        },
        {
          id: 'drbn-calendar',
          title: 'Calendar',
          description: 'Integrated Google Calendar to book appointments',
        },
        {
          id: 'drbn-podcast',
          title: 'Podcast',
          description: 'Integrated podcast RSS to show episodes on site',
        },
        {
          id: 'drbn-seo',
          title: 'SEO',
          description: 'Optimized content for search engines',
        },
      ],
    },
  ],
  showAnimatedBackground: true,
};

const DemoOne = () => {
  return <PortfolioPage {...customPortfolioData} />;
};

export { DemoOne };

